import { Divider as DividerMui, Typography } from '@material-ui/core';
import { Color, Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import styled from 'styled-components';
import { usePostingsPageContext } from './PostingsPageContext';

const List = styled.ul`
  padding-inline-start: 24px;
  margin-top: 8px;
  li {
    margin-bottom: 8px;
  }
`;

const Divider = styled(DividerMui)`
  width: 70px;
  margin-top: 16px;
  background-color: ${Color.Silver500};
`;

const requirements = [
  'Your FMCSA registration is less than 90 days old.',
  'You have fewer than 3 ratings on Super Dispatch.',
  'Fewer than 5 loads have been delivered through Super Dispatch.',
  'Your rating is below 80%.',
  'Your cancellation rate exceeds 10%.',
  'Your USDOT authority is inactive.',
];

export function PostingListEmptyBooking() {
  const { params, setParams } = usePostingsPageContext();

  const handleClick = () => {
    setParams({
      ...params,
      search_criteria: { ...params.search_criteria, show_bookable: false },
    });
  };

  return (
    <Stack space="small" align="center">
      <Box maxWidth="300px">
        <Stack space="xsmall" align="center">
          <Typography variant="h3">No “Book Now” loads available</Typography>
          <Typography align="center" color="textSecondary">
            Meanwhile, explore a variety of options on Super Loadboard and stay
            ahead.
          </Typography>
        </Stack>
      </Box>
      <Button onClick={handleClick}>Search All Available Loads</Button>
      <Divider />
      <Box maxWidth="360px">
        <Typography variant="body1" color="textSecondary" align="left">
          Here are a few reasons why &quot;Book Now&quot; loads might not be
          available to you:
        </Typography>
        <List>
          {requirements.map((requirement) => (
            <li key={requirement}>
              <Typography color="textSecondary">{requirement}</Typography>
            </li>
          ))}
        </List>
      </Box>
    </Stack>
  );
}
